import { useRef, useState } from 'react';

function ImageUploader({ onImageUpload }) {
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFileSelect = (file) => {
    if (!file) return;

    // Only handle PDF files
    if (file.type === 'application/pdf') {
      onImageUpload({
        file: file,
        type: 'pdf',
      });
    } else {
      alert('Please upload a PDF file only.');
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      handleFileSelect(file);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files?.[0];
    if (file) {
      handleFileSelect(file);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div
        onClick={handleClick}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        className={`
          border-4 border-dashed rounded-2xl p-12 text-center cursor-pointer
          transition-all duration-200
          ${isDragging
            ? 'border-indigo-600 dark:border-indigo-400 bg-indigo-50 dark:bg-indigo-900/20'
            : 'border-gray-300 dark:border-gray-600 hover:border-indigo-400 dark:hover:border-indigo-500 bg-white dark:bg-gray-800'
          }
        `}
      >
        <div className="space-y-4">
          <div className="flex justify-center">
            {/* PDF Icon - Page with folded corner and "PDF" text */}
            <svg className="w-20 h-20" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 8C12 5.79086 13.7909 4 16 4H40L52 16V56C52 58.2091 50.2091 60 48 60H16C13.7909 60 12 58.2091 12 56V8Z" fill="#E74C3C" stroke="#C0392B" strokeWidth="2"/>
              <path d="M40 4V12C40 14.2091 41.7909 16 44 16H52" fill="#C0392B"/>
              <text x="32" y="42" fontFamily="Arial, sans-serif" fontSize="16" fontWeight="bold" fill="white" textAnchor="middle">PDF</text>
            </svg>
          </div>
          <div>
            <p className="text-xl font-semibold text-gray-700 dark:text-gray-200 mb-2">
              Upload a PDF
            </p>
            <p className="text-gray-500 dark:text-gray-400">
              Click to browse or drag and drop
            </p>
          </div>
          <p className="text-sm text-gray-400 dark:text-gray-500">
            Supports PDF files only
          </p>
        </div>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept="application/pdf"
        onChange={handleFileInputChange}
        className="hidden"
      />
    </div>
  );
}

export default ImageUploader;
